import useSWR from 'swr'
import { guardClient } from '../_axios'

export type FocusCustomerTask = {
  id: string
  title: string
  description: string | null
  dueDate: string | null
  creator: string
}

export type FocusCustomer = {
  companyId: number
  companyName: string
  summary: string | null
  tasks: FocusCustomerTask[]
}

const focusCustomersFetcher = async (
  urlTail: string
): Promise<{ data: FocusCustomer[] }> => {
  const response = await guardClient
    .get<{ data: FocusCustomer[] }>(urlTail)
    .then((r) => r.data)
  return response
}

export const useFocusCustomers = () => {
  const path = '/company/focus-customers'
  const { data, mutate } = useSWR(path, focusCustomersFetcher, {
    onErrorRetry: () => {
      return
    }
  })
  return { data: data?.data ?? [], mutate }
}
